const header = document.getElementsByClassName('header-sp')[0]
const bottomFixedBar = document.getElementsByClassName('bottom_fixed_bar')[0]
const height = window.pageYOffset
const formArea = document.getElementById("form_area")
const presentBanner = document.getElementById("event_present")
const eventFV = document.getElementById("event_fv")
let position = 0
let lastPosition = 0

const onScroll = () => {
  if(position > height && position > lastPosition) {
    bottomFixedBar.classList.add('-visible')
    if(header) {
      header.classList.add('-invisible')
    }

  }

  if(position < height || position < lastPosition) {
    if (header) {
      header.classList.remove('-invisible')
    }

  }
}

// フォーム表示箇所はバナーを常に非表示にする
const handleFormIntersection = (entries) => {
  const entry = entries[0]

  if (entry.isIntersecting) {
    bottomFixedBar.classList.add('-onform')
  } else {
    bottomFixedBar.classList.remove('-onform')
  }
}
const observer = new IntersectionObserver(handleFormIntersection, { threshold: 0 })

window.addEventListener("scroll", () => {
  position = window.scrollY
  if (bottomFixedBar) {
    onScroll()
    if (eventFV) {
      observer.observe(eventFV)
      
      if(position <= 100){
        bottomFixedBar.classList.remove('-visible')
      }
    }
    if (presentBanner) {
      observer.observe(presentBanner)
    }
    if (formArea) {
      observer.observe(formArea)
    }
  }

  lastPosition = position
})
